import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Stack } from '@mui/material';
import api from '../api/api'
import SuccessMessage from '../components/successMessage';
import ErrorMessage from '../components/errorMessage';

function ChangePassword() {
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const savePassword = (e) => {
        e.preventDefault();

        setShowSuccessMessage(false);
        setShowErrorMessage(false);

        if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
            setShowErrorMessage(true);
            setErrorMessage('Por favor, preencha todos os campos.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setShowErrorMessage(true);
            setErrorMessage('A nova senha e a confirmação não correspondem.');
            return;
        }

        setLoading(true);

        api.put('/usuario/senha', {
            senhaAtual: currentPassword,
            senhaNova: newPassword,
            confirmacaoDeSenha: confirmPassword
        }, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        })
            .then(returnFromApi => {
                setLoading(false);
                setShowSuccessMessage(true);
                setSuccessMessage(returnFromApi.data);

                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            })
            .catch(returnFromApi => {
                setLoading(false);
                setShowErrorMessage(true);
                setErrorMessage(returnFromApi.response?.data || 'Ocorreu um erro ao alterar a senha.');
                console.error("ops! ocorreu um erro" + returnFromApi);

                if (returnFromApi.status === 401) {
                    navigate("/expired-session");
                }
            });
    };

    return (
        <Box
            component="main"
            sx={{
                p: 4,
            }}>
            <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
                Alterar Senha
            </Typography>
            <Typography color="text.secondary">
                Para alterar sua senha, preencha todos os campos.
            </Typography>

            <Box>
                <Paper component="form" onSubmit={savePassword} sx={{ p: 6 }}>
                    <Stack spacing={5}>
                        {showSuccessMessage && <SuccessMessage message={successMessage} show={showSuccessMessage} setShow={setShowSuccessMessage} />}
                        {showErrorMessage && <ErrorMessage message={errorMessage} show={showErrorMessage} setShow={setShowErrorMessage} />}

                        <TextField
                            label="Senha Atual *"
                            type="password"
                            variant="outlined"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            disabled={isLoading}
                        />

                        <TextField
                            label="Nova Senha *"
                            type="password"
                            variant="outlined"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            disabled={isLoading}
                        />

                        <TextField
                            label="Confirmar Nova Senha *"
                            type="password"
                            variant="outlined"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            disabled={isLoading}
                        />

                        <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="right"
                        >
                            <Button
                                component={Link}
                                to="/home"
                                variant="outlined"
                            >
                                Cancelar
                            </Button>

                            <Button
                                type="submit"
                                variant="contained"
                            > Salvar
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Box>
        </Box>
    );
}

export default ChangePassword;